import styled from 'styled-components';

export const FieldBlock = styled.div`
  & + & {
    margin-top: 16px;
  }
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: #4a4a55;
  margin-bottom: 6px;

  span {
    color: #d32f2f;
  }
`;

export const FieldInput = styled.input`
  width: 100% !important;
  min-width: 0;
  height: 44px;
  padding: 0 12px;
  font-size: 14px;
  color: #1a1a22;
  background: #fff;
  border: 1px solid #d5d5de;
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  font-family: inherit;
  appearance: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: #b6b6c2;
  }

  &:hover {
    border-color: #bfbfcc;
  }

  &:focus {
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.14);
  }

  &:disabled {
    background: #f7f7f9;
    color: #9c9ca8;
    cursor: not-allowed;
  }
`;

export const FieldError = styled.div`
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fdecec;
  color: #c0392b;
  font-size: 12.5px;
  line-height: 1.5;
`;
